var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.user)?_c('div',{staticClass:"editor-toolbar"},[_c('header',[_c('ShieldAccountIcon'),_vm._v(" Kurator Bereich ")],1),_c('div',{staticClass:"tools"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }